import { render, staticRenderFns } from "./ProcedimentosDataTable.vue?vue&type=template&id=7779a322"
import script from "./ProcedimentosDataTable.vue?vue&type=script&lang=ts"
export * from "./ProcedimentosDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports